import React from 'react';
import { Button, Card, Typography, Space } from 'antd';
import { ArrowRightOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const { Title, Paragraph } = Typography;

const CustomFieldsRedirect: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleNavigateToAccountSettings = () => {
    navigate('/settings/custom-fields');
  };

  return (
    <div style={{ padding: '24px', maxWidth: '600px', margin: '0 auto' }}>
      <Card>
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
          <Title level={3}>{t('settings:customFields.redirectTitle')}</Title>

          <Paragraph style={{ fontSize: '16px', color: '#666' }}>
            {t('settings:customFields.redirectMessage')}
          </Paragraph>

          <Button
            type="primary"
            size="large"
            icon={<ArrowRightOutlined />}
            onClick={handleNavigateToAccountSettings}
          >
            {t('settings:customFields.goToAccountSettings')}
          </Button>
        </Space>
      </Card>
    </div>
  );
};

export default CustomFieldsRedirect;
